import React, { useEffect } from "react";
import { graphql, useStaticQuery } from "gatsby";
import CookieBanner, { getCookieConsentValue } from "@unum/cookie-banner";
import { useCookie } from "@unum/hooks";
import RichText from "./RichText";
import { GetCookieBannerQuery } from "../../graphql-types";

const IntegratedCookieBanner = () => {
  const [googleConsentsResponse, setGoogleConsentsResponse] = useCookie(
    "google-consent-response"
  );

  const acceptGoogleConsents = () => {
    let current_date = new Date();

    setGoogleConsentsResponse("granted", {
      path: "/",
      expires: new Date(current_date.setDate(current_date.getDate() + 150))
    });
  };

  const denyGoogleConsents = () => {
    setGoogleConsentsResponse("denied");
  };

  useEffect(() => {
    // Disabling overflow manipulation due to scrll lock issue
    // const setBodyOverflow = (value: "hidden" | "visible") => {
    //   const body = document.getElementsByTagName("body")[0];
    //   body.style.overflow = value;
    // };

    const handleConsentRespone = (response: "granted" | "denied") => {
      gtag("consent", "update", {
        ad_storage: response,
        ad_user_data: response,
        ad_personalization: response,
        analytics_storage: response
      });

      // Disabling overflow manipulation due to scrll lock issue
      // setBodyOverflow("visible");
    };

    if (
      googleConsentsResponse === "granted" ||
      googleConsentsResponse === "denied"
    ) {
      handleConsentRespone(googleConsentsResponse);
      // Disabling overflow manipulation due to scrll lock issue
      // } else {
      //   setBodyOverflow("hidden");
    }
  }, [googleConsentsResponse]);

  const cookieBannerQuery = useStaticQuery<GetCookieBannerQuery>(query);
  const data = cookieBannerQuery?.kontentItemSite;

  if (!data) {
    return null;
  }

  const { cookie_policy_title, cookie_policy_body } = data.elements;

  const cookieName = `google-consent-confirmed`;

  if (typeof getCookieConsentValue(cookieName) !== "undefined") {
    return null;
  }

  if (!cookie_policy_title.value) {
    return null;
  }

  return (
    <CookieBanner
      title={cookie_policy_title.value}
      cookieName={cookieName}
      onAccept={acceptGoogleConsents}
      onDecline={denyGoogleConsents}
    >
      <RichText data={cookie_policy_body} />
    </CookieBanner>
  );
};

export default IntegratedCookieBanner;

export const query = graphql`
  query getCookieBanner {
    kontentItemSite {
      id
      elements {
        cookie_policy_title {
          value
        }
        cookie_policy_body {
          ...RichTextFragment
        }
      }
    }
  }
`;
